import { useSelector } from 'react-redux';
import { getSuitCaseData } from '../ducks';

export const useGetItemsForRoulette = () => {
  const { data } = useSelector(getSuitCaseData);
  return {
    items: data.lastRevision.items,
  };
};
